var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time oclock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 443",
    opacity: 0.4,
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 444",
    d: "M9.60039 7.9999C9.60039 8.88356 8.88405 9.5999 8.00039 9.5999C7.11673 9.5999 6.40039 8.88356 6.40039 7.9999C6.40039 7.11625 7.11673 6.3999 8.00039 6.3999C8.88405 6.3999 9.60039 7.11625 9.60039 7.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1134 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99961 2.6001C7.66824 2.6001 7.39961 2.86873 7.39961 3.2001V6.8001C7.39961 7.13147 7.66824 7.4001 7.99961 7.4001C8.33098 7.4001 8.59961 7.13147 8.59961 6.8001V3.2001C8.59961 2.86873 8.33098 2.6001 7.99961 2.6001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOclock);
export default __webpack_public_path__ + "static/media/time-oclock.87626d50c6f983f00ccd7f0b18599d44.svg";
export { ForwardRef as ReactComponent };